import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useRef } from 'react';
import { useAuthValue } from '../contexts/AuthContext';
import { useUserAPI } from '../contexts/UserAPIContext';

const LoadingFallback = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
    <div className="spinner-border text-primary" role="status" aria-hidden="true" />
    <span className="visually-hidden">Carregando...</span>
  </div>
);

const PrivateRoute = ({ allowedRoles }) => {
  const location = useLocation();
  const { user, authLoading } = useAuthValue();
  const { userAPIData, loading, fetchUserData } = useUserAPI();
  const isFetching = useRef(false);

  if (authLoading || loading) {
    return <LoadingFallback />;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!userAPIData) {
    if (!isFetching.current) {
      isFetching.current = true;
      fetchUserData().finally(() => {
        isFetching.current = false;
      });
    }
    return <LoadingFallback />;
  }

  if (allowedRoles && allowedRoles.length > 0) {
    const roleId = userAPIData?.userRole?.id ?? userAPIData?.userRoleId;
    if (!allowedRoles.includes(roleId)) {
      return <Navigate to="/" replace />;
    }
  }

  return <Outlet />;
};

export default PrivateRoute;
export { LoadingFallback };

